export const CONTRAT_TYPE_PRIVE = 'Prive';
export const CONTRAT_TYPE_CONCESSION = 'Concession';
export const CONTRAT_TYPE_SOUS_LOCATION = 'SousLocation';

export const TYPE_FILTRE_DATE_PREAVIS = 'datePreavis';
export const TYPE_FILTRE_DATE_ECHEANCE = 'dateFinEcheance';

export const TYPE_INDEXATION_POURCENTAGE = 'Pourcentage';
export const TYPE_INDEXATION_INDICE = 'Indice';

export const LISTE_TYPE_INDEXATION = [
  { code: TYPE_INDEXATION_POURCENTAGE, libelle: 'detailContrat.indexation.typePourcentage' },
  { code: TYPE_INDEXATION_INDICE, libelle: 'detailContrat.indexation.typeIndice' },
];

export const LISTE_TYPE_CONTRAT = [
  { code: CONTRAT_TYPE_PRIVE, libelle: 'listeContrat.typeContrat.prive' },
  { code: CONTRAT_TYPE_CONCESSION, libelle: 'listeContrat.typeContrat.concession' },
  { code: CONTRAT_TYPE_SOUS_LOCATION, libelle: 'listeContrat.typeContrat.sousLocation' },
];

export const CONTRAT_ETAT_BROUILLON = 'Brouillon';
export const CONTRAT_ETAT_ENREGISTRE = 'Enregistre';
export const CONTRAT_ETAT_CLOS = 'Clos';

export const LISTE_ETAT_CONTRAT = [
  { code: CONTRAT_ETAT_BROUILLON, libelle: 'listeContrat.etatContrat.brouillon' },
  { code: CONTRAT_ETAT_ENREGISTRE, libelle: 'listeContrat.etatContrat.enregistre' },
  { code: CONTRAT_ETAT_CLOS, libelle: 'listeContrat.etatContrat.clos' },
];

export const TERME_PAIEMENT_ECHU = 'Echu';
export const TERME_PAIEMENT_AVANCE = 'Avance';

export const LISTE_TERME_PAIEMENT = [
  { code: TERME_PAIEMENT_ECHU, libelle: 'ajoutEditContrat.echeance.termePaiement.echu' },
  { code: TERME_PAIEMENT_AVANCE, libelle: 'ajoutEditContrat.echeance.termePaiement.avance' },
];

export const MOIS = 'Mois';
export const ANNEE = 'Annee';

export const PERIODICITE_UNITE = [
  { code: MOIS, libelle: 'general.quantity.month' },
  { code: ANNEE, libelle: 'general.quantity.year' },
];

export const TYPE_CONTRAT = 'Contrat';

export const ACTION_RECONDUIRE = 'Reconduire';

export const EXPORT_EXCEL_TYPE_DONNEES_CONTRATS = 'contrats';
export const EXPORT_EXCEL_TYPE_EXPORT_MATERIELS = 'materiels';
export const ECRANS_BAILLEUR_EXPORT_EXCEL = 'ecransbailleur';
export const TYPE_EDITION_CONTRAT_CRIP = 'ContratCrip';
export const TYPE_EDITION_DEMANDE_AVOIR_BAILLEUR = 'DemandeAvoirBailleur';

export const EXPORT_EXCEL_TYPE_DONNEES_A_RAPPROCHER = 'echeancearapprocher';

export const ACTION_CONSTATION_CHARGE = 'ACTION_CONSTATATION_CHARGE';
